import styles from "./Button.module.css";

export default function Button({ children, variant = "primary", className = "", ...props }) {
  const variantClass =
    variant === "ghostLight"
      ? styles.ghostLight
      : variant === "ghostDark"
        ? styles.ghostDark
        : styles.primary;

  return (
    <button
      type="button"
      className={`${styles.button} ${variantClass} ${className}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
}
